module.exports = __webpack_public_path__ + "img/heating-type-03-label-en.asset.1d966998.svg";